import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Arrow = () => (
    <SingePathIcon path="M1.47257 6.66668H8.91924L5.66591 9.92001C5.40591 10.18 5.40591 10.6067 5.66591 10.8667C5.92591 11.1267 6.34591 11.1267 6.60591 10.8667L10.9992 6.47334C11.2592 6.21334 11.2592 5.79334 10.9992 5.53334L6.61257 1.13334C6.48802 1.00851 6.31892 0.938354 6.14257 0.938354C5.96623 0.938354 5.79713 1.00851 5.67257 1.13334C5.41257 1.39334 5.41257 1.81334 5.67257 2.07334L8.91924 5.33334H1.47257C1.10591 5.33334 0.805908 5.63334 0.805908 6.00001C0.805908 6.36668 1.10591 6.66668 1.47257 6.66668Z" />
);

Arrow.viewBox = `0 0 12 12`;
